// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36QIS","importantInfo":"styles_importantInfo__22JTB"};